var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page-group-content"},[_c('div',{staticClass:"header-group-content-top"},[_c('span',[_c('img',{attrs:{"src":_vm.icon,"alt":""}})]),_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"header-group-content-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }